import client from './client'

export const fetchMenu = () => client.get('/menu')
